import gql from 'graphql-tag';

const ShareAndRestrictUserListFragment = gql`
	fragment ShareAndRestrictUserListFragment on PaginatedUserWithRestrictions {
		count
		nodes {
			type
			displayName
			email
			accountId
			profilePicture {
				path
			}
			hasSpaceViewPermission
			hasSpaceEditPermission
			permissionType
			restrictingContent {
				id
				links {
					webui
					base
				}
			}
		}
		pageInfo {
			hasNextPage
			endCursor
		}
	}
`;

const groupFragment = gql`
	fragment groupFragment on PaginatedGroupList {
		count
		nodes {
			id
			name
			permissionType
		}
		pageInfo {
			hasNextPage
			endCursor
		}
	}
`;

export const ShareAndRestrictDialogQuery = gql`
	query ShareAndRestrictDialogQuery(
		$contentId: ID!
		$status: [String]
		$draftShareId: String
		$spaceKey: String!
	) {
		content(id: $contentId, status: $status, draftShareId: $draftShareId) {
			nodes {
				id
				ancestors {
					id
					hasViewRestrictions
					links {
						webui
					}
				}
				hasInheritedRestrictions
				# hasRestrictions
				# hasViewRestrictions
				# title
				# type
				# status
				# subType
				operations {
					operation
					targetType
				}
				restrictions {
					read {
						restrictions {
							userWithRestrictions(start: 0) {
								...ShareAndRestrictUserListFragment
							}
							group(start: 0) {
								...groupFragment
							}
						}
					}
					update {
						restrictions {
							userWithRestrictions(start: 0) {
								...ShareAndRestrictUserListFragment
							}
							group(start: 0) {
								...groupFragment
							}
						}
					}
				}
				# space {
				#   id
				#   containsExternalCollaborators
				#   externalCollaboratorCount
				# }
			}
		}
		user(current: true) {
			id
			displayName
			emails {
				value
				isPrimary
			}
			photos {
				value
				isPrimary
			}
		}
		space(key: $spaceKey) {
			id
			currentUser {
				isAdmin
			}
		}
		# tenant {
		#   editions {
		#     edition
		#   }
		# }
	}

	${ShareAndRestrictUserListFragment}
	${groupFragment}
`;
